import './src/vaadin-side-nav-item.js';
export * from './src/vaadin-side-nav-item.js';
